import React from 'react';

import ErrorPageContainer from './ErrorPageContainer';

function Error404Page() {
  return <ErrorPageContainer heading="404: Page not found">Oops! This link seems to be broken.</ErrorPageContainer>;
}

export default React.memo(Error404Page);
